const app = new Vue({
  el: '#app',
  components: {
    Hooper: window.Hooper.Hooper,
    Slide: window.Hooper.Slide,
    HooperNavigation: window.Hooper.Navigation,
  },
  data: {
    games: [],
    year: '',
    seriesList: [],
    teamIds: [],
    isMobile: window.innerWidth <= 768,
    mainVisualIndex: 0,
    mainVisualSettings: {
      autoPlay: true,
      playSpeed: 6000,
      transition: 1000,
      centerMode: true,
      wheelControl: false,
      infiniteScroll: true,
    },
    hooperSettings: {
      autoPlay: true,
      trimWhiteSpace: true,
      playSpeed: 3000,
      transition: 500,
      infiniteScroll: true,
      centerMode: true,
      itemsToShow: 1.3,
      wheelControl: false,
      breakpoints: {
        768: { itemsToShow: 2 },
        1024: { itemsToShow: 3.5 },
      },
    },
  },
  async created() {
    window.addEventListener('resize', this.checkIsMobile)

    let games
    let seriesIds

    // 最新の試合結果を取得する
    {
      const {
        data: { entries }
      } = await axios.post('/api/collections/get/games', {
        filter: { gameOver: true },
        sort: { date: -1 },
        limit: 10,
        populate: 1,
      })

      games = entries

      seriesIds = new Set(entries.map((item) => {
        return item.seriesId
      }))
    }

    // 最新の試合結果に関連する公式戦情報を取得する
    {
      const {
        data: { entries },
      } = await axios.post('/api/collections/get/series', {
        filter: {
          _id: { $in: Array.from(seriesIds.values()) },
        },
        fields: { year: 1, shortName: 1, type: 1 },
      })

      games.forEach((game) => {
        game.series = _.find(entries, (item) => {
          return item._id === game.seriesId
        })
      })
    }

    this.games = games

    // 過去2年分の公式戦データを読み込んで、最新年度の
    {
      const {
        data: { entries },
      } = await axios.post('/api/collections/get/series', {
        filter: {
          year: { $gte: `${dayjs().year() - 2}` },
          requirements: { $in: ['1部', '2部', '3部', '4部', 'チャレンジリーグ'] },
          published: true,
        },
        fields: { year: 1, shortName: 1 },
        sort: { year: -1, requirements: 1 },
      })

      this.year = _.get(entries, [0, 'year'], dayjs().year())

      this.seriesList = entries.filter((item) => {
        return item.year === this.year
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIsMobile)
  },
  /*
  mounted() {
    // Twitterウィジェット
    const container = document.getElementById('twitter-timeline-container')
    const twitterScript = document.createElement('script')
    twitterScript.src = 'https://platform.twitter.com/widgets.js'
    twitterScript.async = true
    twitterScript.charset = 'utf-8'
    container.appendChild(twitterScript)
  },
  */
  computed: {
    hasMobileImage() {
      return mainVisualsMobile.length > 0
    },
    mainVisualImages() {
      return this.isMobile && this.hasMobileImage
        ? mainVisualsMobile
        : mainVisuals
    },
  },
  methods: {
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    mainVisualBeforeSlide({ slideFrom }) {
      if (_.isNumber(slideFrom)) {
        this.mainVisualIndex = (slideFrom + 1) % this.mainVisualImages.length
        return
      }
      this.mainVisualIndex = 0
    },
  },
})
